import Icon from '../components/Icon.vue'

Icon.register({
  'shoe-prints': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M192 160H224V32H192C156.7 32 128 60.6 128 96S156.7 160 192 160zM0 416C0 451.4 28.6 480 64 480H96V352H64C28.6 352 0 380.6 0 416zM337.5 288C302.6 288 261.3 301.1 232.7 320 207.9 336.4 188.2 352 128 352V480L185.5 496C211.7 503.3 238.5 509.1 265.8 511 298.5 513.3 331.4 511.7 363.4 504.8 472.9 481.3 512 429.2 512 384 512 320 427.8 288 337.5 288zM491.4 7.2C459.4 0.3 426.5-1.3 393.8 1 366.5 2.9 339.7 8.8 313.5 16L256 32V160C316.2 160 335.9 175.6 360.7 192 389.3 210.9 430.6 224 465.5 224 555.8 224 640 192 640 128 640 82.8 600.9 30.7 491.4 7.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shoe-prints.js
// module id = vL0K
// module chunks = 144